import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { CartItem } from './CartItem';
import { CONFIG } from '../data/config';
import { CartItemType } from '../types/types';
interface CartProps {
  onCheckout: () => void;
  onEditItem: (item: CartItemType) => void;
}
export function Cart({
  onCheckout,
  onEditItem
}: CartProps) {
  const {
    isCartOpen,
    toggleCart,
    items,
    cartTotal,
    updateQuantity,
    removeItem
  } = useCart();
  return <AnimatePresence data-id="element-77">
      {isCartOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={toggleCart} className="fixed inset-0 bg-black/40 z-50 backdrop-blur-sm max-w-md mx-auto" data-id="element-78" />
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed bottom-0 left-0 right-0 z-50 bg-carbon rounded-t-3xl max-h-[85vh] flex flex-col max-w-md mx-auto shadow-2xl border-t border-gray-800" data-id="element-79">
            <div className="bg-surface px-6 py-4 rounded-t-3xl flex items-center justify-between border-b border-gray-800" data-id="element-80">
              <h2 className="font-heading font-bold text-xl text-white flex items-center gap-2 tracking-wide" data-id="element-81">
                <ShoppingBagIcon className="w-5 h-5 text-verde" data-id="element-82" />
                Tu Pedido
              </h2>
              <button onClick={toggleCart} className="p-2 bg-surface-light rounded-full text-gray-400 hover:text-white" data-id="element-83">
                <XIcon className="w-5 h-5" data-id="element-84" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-4" data-id="element-85">
              {items.length === 0 ? <div className="flex flex-col items-center justify-center h-48 text-gray-400" data-id="element-86">
                  <ShoppingBagIcon className="w-12 h-12 mb-3 opacity-50" data-id="element-87" />
                  <p data-id="element-88">Tu carrito está vacío</p>
                </div> : <div className="space-y-1" data-id="element-89">
                  {items.map(item => <CartItem key={item.id} item={item} onUpdateQuantity={updateQuantity} onRemove={removeItem} onEdit={i => {
              toggleCart();
              onEditItem(i);
            }} data-id="element-90" />)}
                </div>}
            </div>

            {items.length > 0 && <div className="bg-surface p-6 border-t border-gray-800 pb-safe" data-id="element-91">
                <div className="flex justify-between items-center mb-4" data-id="element-92">
                  <span className="text-gray-400 font-medium" data-id="element-93">Subtotal</span>
                  <span className="font-bold text-lg text-white" data-id="element-94">
                    {CONFIG.CURRENCY_SYMBOL}
                    {cartTotal.toLocaleString()}
                  </span>
                </div>
                <button onClick={() => {
            toggleCart();
            onCheckout();
          }} className="w-full bg-terracota text-white font-semibold py-4 rounded-xl shadow-lg shadow-terracota/20 hover:bg-[#9a3a18] transition-colors active:scale-95 border border-white/10" data-id="element-95">
                  Continuar al Checkout
                </button>
              </div>}
          </motion.div>
        </>}
    </AnimatePresence>;
}